import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import { standardizeAndMagnifyEffectHtmlImages } from "../../../components/datagrid/renderers/htmlColumn";

export const columns: GridColDef[] = [
  {
    field: "rebates.favi",
    headerName: "Favi",
    description: "Favi",
    valueGetter: (value, row) => row.rebates?.favi,
    renderCell: (params) => {
      if (!params.value) return null;

      // Extract src from the img tag string (handles quoted or unquoted src)
      const srcMatch = params.value.match(/src=["']?([^"'\s>]+)["']?/);
      const src = srcMatch ? srcMatch[1] : "";

      return (
        <img
          src={src}
          alt="favi"
          style={{ width: "25px", height: "25px", objectFit: "contain" }}
        />
      );
    },
    width: 120,
    editable: true,
  },
  {
    field: "rebates.store",
    headerName: "Store",
    description: "Store",
    valueGetter: (value, row) => row.rebates?.store,
    width: 120,
    editable: true,
  },
  {
    field: "rebates.ml",
    headerName: "ML",
    description: "ML",
    valueGetter: (value, row) => row.rebates?.ml,
    width: 100,
    editable: true,
  },
  {
    field: "rebates.coupon",
    headerName: "Coupon",
    description: "Coupon",
    valueGetter: (value, row) => row.rebates?.coupon,
    width: 120,
    editable: true,
  },
  {
    field: "rebates.incentive",
    headerName: "Incentive",
    description: "Incentive",
    valueGetter: (value, row) => row.rebates?.incentive,
    width: 130,
    editable: true,
  },
  {
    field: "rebates.rebate",
    headerName: "Rebate",
    description: "Rebate",
    valueGetter: (value, row) => row.rebates?.rebate,
    width: 120,
    editable: true,
  },
  {
    field: "rebates.forex",
    headerName: "Forex",
    description: "Forex",
    valueGetter: (value, row) => row.rebates?.forex,
    width: 120,
    editable: true,
  },
  {
    field: "rebates.shipping",
    headerName: "Shipping",
    description: "Shipping",
    valueGetter: (value, row) => row.rebates?.shipping,
    width: 130,
    editable: true,
  },
  {
    field: "rebates.winner",
    headerName: "Winner",
    description: "Winner",
    valueGetter: (value, row) => row.rebates?.winner,
    width: 120,
    editable: true,
    renderCell: (params: GridRenderCellParams) => (
      <span
        dangerouslySetInnerHTML={{
          __html: standardizeAndMagnifyEffectHtmlImages(params.value),
        }}
      />
    ),
  },
  {
    field: "rebates.changed",
    headerName: "Changed",
    description: "Changed",
    valueGetter: (value, row) => row.rebates?.changed,
    width: 120,
    editable: true,
  },
  {
    field: "rebates.notes",
    headerName: "Notes",
    description: "Notes",
    valueGetter: (value, row) => row.rebates?.notes,
    width: 150,
    editable: true,
    renderCell: (params: GridRenderCellParams) => (
      <span
        dangerouslySetInnerHTML={{
          __html: standardizeAndMagnifyEffectHtmlImages(params.value),
        }}
      />
    ),
  },
  {
    field: "rebates.dtbalg1",
    headerName: "DTBAlg1",
    description: "DTBAlg1",
    valueGetter: (value, row) => row.rebates?.dtbalg1,
    width: 130,
    editable: true,
  },
  {
    field: "rebates.dtbalg2",
    headerName: "DTBAlg2",
    description: "DTBAlg2",
    valueGetter: (value, row) => row.rebates?.dtbalg2,
    width: 130,
    editable: true,
  },
  {
    field: "rebates.shippingrule",
    headerName: "ShipRule",
    description: "ShipRule",
    valueGetter: (value, row) => row.rebates?.shippingrule,
    width: 140,
    editable: true,
  },
  {
    field: "rebates.todayscost",
    headerName: "Today's Cost",
    description: "todayscost",
    valueGetter: (value, row) => row.rebates?.todayscost,
    width: 140,
    editable: true,
  },
  {
    field: "rebates.promotions",
    headerName: "Promotion",
    description: "Promotion",
    valueGetter: (value, row) => row.rebates?.promotions,
    width: 140,
    editable: true,
    renderCell: (params: GridRenderCellParams) => (
      <span
        dangerouslySetInnerHTML={{
          __html: standardizeAndMagnifyEffectHtmlImages(params.value),
        }}
      />
    ),
  },
];
